export default __webpack_public_path__ + "static/media/754_bp.b2865796.svg";